// Define Global Layout for stubhub.com
import React from 'react';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { UnifiedLayoutWithRouter } from '@stubhub/react-unified-app';

import VirtualAssistantWrapper from './modules/react-virtual-assistant-wrapper';
import TrackListener from './tracking/track-listener';

import './index.scss';

const Layout = (props) => {
  const { defaultLocale: locale } = props;

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        keepPreviousData: true,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <TrackListener />
      <VirtualAssistantWrapper locale={locale} />
      <UnifiedLayoutWithRouter {...props} />
    </QueryClientProvider>
  );
};

Layout.propTypes = {
  defaultLocale: PropTypes.string
};

export default Layout;
